import { useForm, UseFormRegister, FieldErrors } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAuthContext } from 'contexts/Auth';
import yup from 'utils/yup';

type UseFormType = Partial<{
  register: UseFormRegister<any>;
  errors: FieldErrors;
}> & {
  onSubmit: () => void;
};

const schema = yup.object().shape({
  email: yup.string().email().required().label('E-mail'),
});

export default (
  { goToPassword }:{ goToPassword: () => void },
):UseFormType => {
  const { email, setEmail } = useAuthContext();

  const {
    register, handleSubmit, formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: { email },
  });

  const onSubmit = handleSubmit((formData) => {
    if (formData?.email) {
      setEmail(formData.email);
      goToPassword();
    }
  });

  return {
    register,
    errors,
    onSubmit,
  };
};
